import * as Yup from 'yup';
import { PqrCallInfo } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrCallInfo = {
    callId: '',
};

export const validationSchema = Yup.object({
    callId: Yup.string().max(
        100,
        'El call ID debe tener 100 caracteres alfanuméricos como máximo'
    ),
});
